<template>
  <IconBase
    :width="iconSize"
    :height="iconHeight[iconSize]"
    :view-box="`0 0 ${iconSize} ${iconHeight[iconSize]}`"
    icon-color="transparent"
  >
    <IconNoSearchResult158px :icon-color="iconColor" v-if="iconSize === 158" />
    <IconNoSearchResult103px
      :icon-color="iconColor"
      v-else-if="iconSize === 103"
    />
  </IconBase>
</template>

<script lang="ts">
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconNoSearchResult158px from "@/common/components/icons/IconNoSearchResult158px.vue";
import IconNoSearchResult103px from "@/common/components/icons/IconNoSearchResult103px.vue";
import { Options, Vue } from 'vue-class-component';

@Options({
  props: {
	iconSize: { type: Number, default: 158 },
	iconColor: { type: String, default: "#ee1c25" }
  },
  components: {
    IconBase,
    IconNoSearchResult158px,
    IconNoSearchResult103px
  }
})
export default class IconNoSearchResult extends Vue {
  iconSize!: number;
  iconColor!: string;

  iconHeight = {
    158: 163,
    103: 105
  };
}
</script>
